import { safePrintWindow, escapeHtml } from '../../utils/printUtils';

// Shared 3-inch slip styles: fluid width (like the token slip) so it fills whatever paper the printer uses
export const THERMAL_CSS = `@page{margin:2mm}
  body{font-family:Arial,sans-serif;color:#000;margin:0;padding:0 2px;width:auto;font-size:15px;line-height:1.3}
  .c{text-align:center}.b{font-weight:800}.big{font-size:22px;font-weight:900}
  .hr{border-top:2px dashed #000;margin:6px 0}
  table{width:100%;border-collapse:collapse}td,th{padding:2px 0;vertical-align:top;font-size:15px}
  th{text-align:left;border-bottom:2px solid #000;font-weight:800}.n{text-align:right;white-space:nowrap;padding-left:6px}
  .tot td{border-top:2px solid #000;font-weight:900;font-size:16px}.sec{font-weight:900;margin-top:8px;text-transform:uppercase;font-size:15px;text-decoration:underline}
  .loss{font-weight:900}.sig{margin-top:34px;display:flex;justify-content:space-between}.sig span{border-top:1px solid #000;width:45%;text-align:center;font-size:13px}`;

export const THERMAL_HEAD = `<div class="c big">K.M. MULTI SPECIALITY CLINIC</div><div class="c" style="font-size:13px">Koliyanur &bull; 86085 95239</div>`;

const rs = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

export const printNursingEntries = (entries, dateLabel) => {
  const totals = {};
  entries.forEach((e) => (e.services || []).forEach((s) => {
    const amt = (s.cost || 0) * (s.quantity || 1);
    if (amt <= 0) return; // ₹0 (fee-included) services are left off the pharmacy slip
    const t = totals[s.name] || (totals[s.name] = { count: 0, amount: 0 });
    t.count += s.quantity || 1;
    t.amount += amt;
  }));
  const list = Object.entries(totals).sort((a, b) => b[1].amount - a[1].amount);
  const totRows = list.map(([n, t]) => `<tr><td>${escapeHtml(n)}</td><td class="n">${t.count}</td><td class="n">${rs(t.amount)}</td></tr>`).join('');
  const grand = list.reduce((s, [, t]) => s + t.amount, 0);
  const qty = list.reduce((s, [, t]) => s + t.count, 0);
  const body = `${THERMAL_HEAD}<div class="hr"></div>
    <div class="c b">NURSING &mdash; FOR PHARMACY</div><div class="c">${escapeHtml(dateLabel)}</div><div class="hr"></div>
    <table><tr><th>Service</th><th class="n">Qty</th><th class="n">Amount</th></tr>${totRows || '<tr><td colspan="3">No paid services</td></tr>'}
      <tr class="tot"><td>TOTAL</td><td class="n">${qty}</td><td class="n">${rs(grand)}</td></tr></table>
    <div class="sig"><span>Nurse</span><span>Pharmacy</span></div>
    <div class="c" style="font-size:12px;margin-top:6px">Printed ${new Date().toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true })}</div>`;
  safePrintWindow('Nursing for Pharmacy', `<style>${THERMAL_CSS}</style>${body}`);
};
